import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Constant } from '../constant';

var jsonResponse: any;
@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  constructor(private http: HttpClient, private constant: Constant) {
  }

  // Get employee list
  getEmployee(): Observable<any> {
    return this.http.get<any>(this.constant.API_ENDPOINT + '/employee/all');
  }

  // Get employee by id
  getEmployeeById(id): Observable<any> {
    return this.http.get<any>(this.constant.API_ENDPOINT + '/employee/' + id);
  }

  // Update employee by id
  updateEmployee(id, employee): Observable<any> {
    return this.http.put<any>(this.constant.API_ENDPOINT + '/employee/' + id, JSON.stringify(employee),
    {
      headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'X-User': 'test'
      })
    }).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  // Add employee
  addEmployee(employee): Observable<any> {
    return this.http.post<any>(this.constant.API_ENDPOINT + '/employee', JSON.stringify(employee),
    {
      headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'X-User': 'test'
      })
    }).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  // Delete employee by id
  deleteEmployee(id): Observable<any> {
    return this.http.patch<any>(this.constant.API_ENDPOINT + '/employee/' + id,
    {
      headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'X-User': 'test'
      })
    }).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  // Error handling
  handleError(error) {
  let errorMessage = '';
  if(error.error instanceof ErrorEvent) {
  // Get client-side error
  errorMessage = error.error.message;
  } else {
  // Get server-side error
  errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
  }
  //window.alert(errorMessage);
  return throwError(errorMessage);
  }
}